import { useEffect, useState } from "react";
import { IOrganiser, PermissionPackage } from "@evennt-tech/api-v2-core";
import { OrganiserCompanyToOrganiserRole } from "@evennt-tech/api-v2-core/dist/organiser-company/enums";

export default (organiser: IOrganiser | null): boolean | null => {
  const [isAdminVendr, setIsAdminVendr] = useState<boolean | null>(null);

  useEffect(() => {
    const check = async () => {
      if (!organiser) {
        setIsAdminVendr(false);
        return;
      }

      const hasVendr = organiser.permissionPackages?.includes(
        PermissionPackage.VENDR
      );

      if (!hasVendr) {
        setIsAdminVendr(false);
        return;
      }

      try {
        const isOrganiserCompanyAdmin =
          organiser?.organiserCompanyToOrganisers?.[0]?.role ===
          OrganiserCompanyToOrganiserRole.ADMIN;

        setIsAdminVendr(isOrganiserCompanyAdmin && hasVendr);
      } catch (err) {
        console.error("Failed to check admin vendr:", err);
        setIsAdminVendr(false);
      }
    };

    check();
  }, [organiser]);

  return isAdminVendr;
};
